// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"21fcb6e7","453":"74b335da"}[chunkId] + ".chunk.js";
};